import { render } from "./RouteDashboard.vue?vue&type=template&id=8262f23a&scoped=true"
import script from "./RouteDashboard.vue?vue&type=script&lang=js"
export * from "./RouteDashboard.vue?vue&type=script&lang=js"

import "./RouteDashboard.vue?vue&type=style&index=0&id=8262f23a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8262f23a"]])

export default __exports__